(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-instructions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-instructions-switcher')) {
    customElements.define('product-instructions-switcher', class extends HTMLElement {
      connectedCallback() {
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);

        this.select = this.querySelector('[data-product-select]');
        if (this.select) this.select.addEventListener('change', this.handleSelectChange);

        const activeTab = this.querySelector('[data-instructions-tab][aria-selected="true"]');
        const firstTab = this.querySelector('[data-instructions-tab]');
        const initialTab = activeTab || firstTab;
        if (initialTab) this.activate(initialTab.dataset.productId);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        if (this.select) this.select.removeEventListener('change', this.handleSelectChange);
      }

      handleClick(event) {
        if (!(event.target instanceof Element)) return;
        const tab = event.target.closest('[data-instructions-tab]');
        if (tab && this.contains(tab)) this.activate(tab.dataset.productId);
      }

      handleSelectChange() {
        if (this.select) this.activate(this.select.value);
      }

      handleKeydown(event) {
        if (!(event.target instanceof Element)) return;
        const currentTab = event.target.closest('[data-instructions-tab]');
        if (!currentTab || !this.contains(currentTab)) return;

        const tabs = Array.from(this.querySelectorAll('[data-instructions-tab]'));
        const currentIndex = tabs.indexOf(currentTab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;

        event.preventDefault();
        const nextTab = tabs[nextIndex];
        this.activate(nextTab.dataset.productId);
        nextTab.focus({ preventScroll: true });
      }

      activate(productId) {
        const tabs = Array.from(this.querySelectorAll('[data-instructions-tab]'));
        const panels = Array.from(this.querySelectorAll('[data-instructions-panel]'));
        if (!tabs.some((tab) => tab.dataset.productId === productId)) return;

        tabs.forEach((tab) => {
          const active = tab.dataset.productId === productId;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.productId !== productId;
        });

        if (this.select) this.select.value = productId;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
